import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { Channel } from '@t/productOffering.types';
import { ChannelListSideModal } from '@components/ProductOffers/modals/ChannelListSideModal';
import { ChannelLogoTooltip } from './ChannelLogoTooltip';

interface TVChannelLogosProps {
  channels: Channel[];
  maxVisible?: number;
  tooltipPlacement?: 'left' | 'right' | 'top';
  logoWidth?: number | string;
  logoHeight?: number | string;
}

const MAX_VISIBLE = 4;

export const TVChannelLogos = ({
  channels,
  maxVisible,
  tooltipPlacement = 'top',
  logoWidth,
  logoHeight,
}: TVChannelLogosProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const effectiveMax = maxVisible ?? MAX_VISIBLE;
  const visible = Number.isFinite(effectiveMax) ? channels.slice(0, effectiveMax) : channels;
  const remaining = Number.isFinite(effectiveMax) ? channels.length - effectiveMax : 0;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        {visible.map((channel, i) => (
          <ChannelLogoTooltip
            key={i}
            channel={channel}
            placement={tooltipPlacement}
            logoWidth={logoWidth}
            logoHeight={logoHeight}
          />
        ))}

        {remaining > 0 && (
          <Button variant="channelMore" size="small" onClick={() => setDrawerOpen(true)}>
            +{remaining} More
          </Button>
        )}
      </Box>

      <ChannelListSideModal open={drawerOpen} onClose={() => setDrawerOpen(false)} channels={channels} />
    </>
  );
};
